import type { TItemType } from '../types/items.types';

// Leaf helper (type-only TItemType import) so cache modules can use it without pulling the
// @shared/helpers runtime barrel graph - see the "Runtime enums" note in AGENTS.md.
// The object key used to index an item detail cache (`oldData.doc` vs `oldData.file`).
export const docOrFileKey = (itemType: TItemType): 'doc' | 'file' => (itemType === 'DOCUMENT' ? 'doc' : 'file');
